import axiosTokenInstance from 'services/api/backoffice';
import { TRANSFER_SALES, TRANSFER_SALES_ERROR } from '_models/redux/types';

// Action function
export const transferSalesAction = (params) => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.post(
      `/api/callcenter/sims/orders/register-purchase-by-transfer`,
      params,
    );

    const { data, status } = response || {};

    dispatch({
      type: TRANSFER_SALES,
      payload: data || {},
      status: status || {},
      method: 'post',
    });
  } catch (e) {
    dispatch({
      type: TRANSFER_SALES_ERROR,
      payload: e || {},
    });
  }
};
